module.exports = __webpack_public_path__ + "img/bidsLong.07d2d7e4.svg";